import {Vacature} from '../../models/vacature';
import {PublicatieStatus} from '../../models/publicatie-status';
import {Component, inject, Input, LOCALE_ID} from '@angular/core';
import {formatDate, NgClass} from '@angular/common';
import {OlaType} from '../../models/ola-type';
import {OlaNiveau} from '../../models/ola-niveau';
import {DATUM_FORMAT} from '../../app.config';

@Component({
  selector: 'mvw-vacature-detail',
  templateUrl: './vacature-detail.component.html',
  imports: [NgClass]
})
export class VacatureDetailComponent {

  private readonly locale = inject(LOCALE_ID);
  private readonly datumFormat = inject(DATUM_FORMAT);

  @Input() vacature!: Vacature;

  getStatus(): string {
    switch (this.vacature.publicatieStatus) {
      case PublicatieStatus.Gepubliceerd: {
        return 'GEPUBLICEERD';
      }
      case PublicatieStatus.NietGepubliceerd: {
        return 'NIET GEPUBLICEERD';
      }
      case PublicatieStatus.Afgesloten: {
        return 'AFGESLOTEN';
      }
      default: {
        return '';
      }
    }
  }

  isAfgesloten(): boolean {
    return PublicatieStatus.Afgesloten === this.vacature.publicatieStatus;
  }

  getPublicatieInformatieVanTot(): string {
    const {startDatum, eindDatum} = this.vacature.publicatieInformatie;
    if (startDatum && eindDatum) {
      const formatStartDatum = this.getFormatDate(startDatum);
      const formatEindDatum = this.getFormatDate(eindDatum);
      return `van ${formatStartDatum} tot ${formatEindDatum}`;
    } else if (startDatum) {
      const formatStartDatum = this.getFormatDate(startDatum);
      return `van ${formatStartDatum}`;
    } else if (eindDatum) {
      const formatEindDatum = this.getFormatDate(eindDatum);
      return `tot ${formatEindDatum}`;
    } else {
      return '';
    }
  }

  getToekomstigGepubliceerdMededeling(): string {
    if (this.vacature.publicatieStatus !== PublicatieStatus.Gepubliceerd && this.heeftDatumIngevuld()) {
      return 'Gepubliceerd ';
    } else {
      return '';
    }
  }

  heeftDatumIngevuld(): boolean {
    return !!(this.vacature.publicatieInformatie.startDatum ?? this.vacature.publicatieInformatie.eindDatum);
  }

  heeftOla(): boolean {
    return !!this.vacature.olaInformatie;
  }

  heeftMeerInfo(): boolean {
    return !!this.vacature.olaInformatie?.isMeerInfoBeschikbaar;
  }

  bepaalOlaType(): string {
    if (this.vacature.olaInformatie) {
      switch (this.vacature.olaInformatie.type) {
        case OlaType.ControleerHetGekozenJobdomein: {
          return 'Controleer het gekozen jobdomein.';
        }
        case OlaType.GeenAutomatischeVerzendingMogelijk: {
          return 'Geen automatische verzending mogelijk.';
        }
        case OlaType.GevraagdInhoudelijkNazichtBezig: {
          return 'Gevraagd inhoudelijk nazicht bezig.';
        }
        case OlaType.NietPubliceerbaar: {
          return 'Niet publiceerbaar.';
        }
        case OlaType.TegenstellingenGevonden: {
          return 'Tegenstellingen gevonden.';
        }
        default: {
          return '';
        }
      }
    }
    return '';
  }

  bepaalOlaNiveau(): string {
    if (this.vacature.olaInformatie) {
      switch (this.vacature.olaInformatie.niveau) {
        case OlaNiveau.ERROR: {
          return '-danger action-warning';
        }
        case OlaNiveau.WARNING: {
          return '-warning action-warning';
        }
        case OlaNiveau.INFO: {
          return '-info action-info';
        }
        default: {
          return '';
        }
      }
    }
    return '';
  }

  private getFormatDate(datum: Date): string {
    return formatDate(datum, this.datumFormat, this.locale);
  }

}
